import {colors} from 'shells/colors/colors';
import {ChatBubbleDoubleRegularIcon} from 'shells/icon';
import {Body} from 'shells/typography/body';

interface Props {
    text: string;
}

export function ChatbotReportTableEmptyState(props: Props) {
    return (
        <div className='flex flex-dir-col gap-4 align-center justify-center py-16'>
            {/* @ts-expect-error */}
            <ChatBubbleDoubleRegularIcon size={24} color={colors.greyXlt} />
            <Body size='small' color='placeholder'>
                {props.text}
            </Body>
        </div>
    );
}
